var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('module',{attrs:{"enable-flex":""}},[_c('div',{staticClass:"welcome flex-grow flex-center"},[_c('img',{attrs:{"src":require("@/assets/image/welcome.png"),"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }